<template>
    <div class="l-main">
        <div class="l-main-content">

        <div class="row p-left p-right p-top">
            <div class="col-6">
                <div class="text-title">
                    <h2 class="text-medium">Mpesa Reconcilation</h2>
                </div>
            </div>
            <div class="col-6 text-right">
                <div class="l-input inline">
                    <i class=" search icon"></i>
                    <input v-on:keyup.enter="searchMatches" type="text" placeholder="Search..." v-model="search_match">
                </div>

                <div class="l-input inline">
                    <i class="icon-calendar"></i>
                    <input name="dates"  @focus="onFocus()"  placeholder="Choose date" />
                </div>

                <button  @click="upload" class="ui blue button margin-left-md"><i class="fa fa-upload"></i></button>


            </div>
        </div>
                <div class="row">
                    <loader v-show='loading' />
                    <div class="col">
                        <vuetable ref="vuetable"
                                  :api-url="vueurl"
                                  :fields="columns"
                                  :sort-order="sortOrder"
                                  :append-params="moreParams"
                                  :per-page="15"
                                  @vuetable:pagination-data="onPaginationData"
                                  @vuetable:loading="onLoading"
                                  @vuetable:loaded="onLoaded"
                        >

                            <template  v-slot:status-slot="props">

                                <div  v-if="(props.rowData.status === '0' && !props.rowData.description)"><strong>PENDING</strong></div>
                                <div  style="text-transform:uppercase;" v-if="(props.rowData.status === '0' && props.rowData.description)"><strong>{{props.rowData.description}}</strong></div>
                                <div  v-if="props.rowData.status === '1'"><strong>SUCCESS</strong></div>

                            </template>

                            <template  v-slot:actions="props">
                                <button class="ui blue button" @click="onActionClicked('edit', props.rowData)"><i class="fa fa-pencil"></i></button>
                                <button class="ui green button" @click="onActionClicked('confirm', props.rowData)"> <i class="fa-check-square"></i></button>
                            </template>



                        </vuetable>
                        <div class="vuetable-pagination ui basic segment grid">
                            <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>

                            <vuetable-pagination ref="pagination"
                                                 @vuetable-pagination:change-page="onChangePage"
                            ></vuetable-pagination>
                        </div>
                    </div>
                </div>

        </div>


        <reconcile v-if="deposit_data" :data="deposit_data"/>
        <deposit v-if="deposit_data" :data="deposit_data"/>
        <upload v-if="deposit_mpesa" :data="deposit_mpesa" />
    </div>




</template>

<script>

    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
    // import modalApprove from "../bets/modal-approve";
    import loader from "@/components/loader"
    // import markets from "../modals/markets";
    import reconcile from "../modals/reconcile"
    import deposit from "../modals/deposit"
    import upload from "../modals/deposit_reconcile"

    import {config} from '../config/config';


    export default {


        components: {
             Vuetable, VuetablePagination, VuetablePaginationInfo,loader,reconcile,deposit,upload,config
        },
        name: 'mpesa',

        data() {
            return {
                vueurl:config.baseURL+'odibets/mpesa/reconcile',
                loading: true,
                selected_data: {},
                deposit_data:'',
                deposit_mpesa:'',
                columns: [
                    {
                        name: 'msisdn',
                        title: 'Phone number',
                        sortField: 'mp.msisdn',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'

                    },

                    {
                        name: 'mpesa_code',
                        title: 'MPESA Code ',
                        sortField: 'mp.mpesa_code',
                        titleClass: '',
                        dataClass: ''

                    },
                    {
                        name: 'mpesa_amt',
                        title: 'Deposit Amout  ',
                        sortField: 'mt.mpesa_amt',
                        titleClass: '',
                        dataClass: ''

                    },
                    {
                        name: 'status-slot',
                        title: 'status',
                        titleClass: '',
                        dataClass: '',

                    },

                    {
                        name: 'username',
                        title: 'CS Agent ',
                        titleClass: ''
                    },
                    {
                        name: 'transaction_time',
                        title: 'Date Deposited',
                        sortField: 'transaction_time',
                        callback: 'depositedAt'
                    },
                    'actions'


                ],
                range:'',
                user_id:'',
                role:'',
                token:'',
                search_match:'',
                sortOrder: [{
                    field: 'mp.created',
                    direction: 'desc'
                }],
                is_partial_resulting: false,
                moreParams: {
                    start: '',
                    filter: '',
                    end: '',
                    token: this.token,
                }

            }
        },


        mounted() {

            var vm=this;

            var start = moment();
            var end = moment();

            function cb(start, end) {
                vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                $('#reportrange span').html(start.format('D MMM, YYYY') + ' - ' + end.format('D MMM, YYYY'));
            }

            $('#reportrange').daterangepicker({
                startDate: start,
                endDate: end,
                autoApply:true,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            }, cb);

            cb(start, end);

        },


        created: function(){

            var vm=this;


            vm.checktimer();

            var obj = window.localStorage.getItem('user_info');

            var jsonData = JSON.parse(obj);
            var rolee=jsonData.role;
            var userr=jsonData.id;
            var tokenn=jsonData.token;

            vm.role=rolee;
            vm.user_id=userr;
            vm.token=tokenn;

            if((vm.role  !=2 && vm.role !=3 && vm.role !=5)){

                vm.$router.push({name: 'login'});
            }

            var start = moment();
            var end = moment();

            vm.moreParams.start=start.format('YYYY-MM-DD');
            vm.moreParams.end=end.format('YYYY-MM-DD');
            vm.moreParams.token=vm.token;
            
        },





        watch: {
            data(newVal, oldVal) {
                this.$refs.vuetable.reload();
            },
            range(){

                var start = this.range[0];
                var end = this.range[1];
                this.start= moment(start).format('YYYY-MM-DD');
                this.end= moment(end).format('YYYY-MM-DD');
                console.log("am reaching here ")
                this.moreParams.start = this.start;
                this.moreParams.end = this.end;
                this.moreParams.token = this.token;
                this.$refs.vuetable.reload();
            }
        },



        methods: {


            onActionClicked(action, data) {
                // $('#modal-approvals').modal({centered: false}).modal("show");
                console.log("slot actions: on-click", data);


                var vm=this;

                if (action == 'confirm') {

                    vm.$swal.fire({
                        title: 'Confirm DEPOSIT?',
                        text: "If you are sure, Proceed with Bet Confirmation:!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Confirm!'
                    }).then((result) => {
                        if (result.value) {

                            var payload = {
                                msisdn: data.msisdn,
                                trans_id: data.mpesa_code,
                                amount: data.mpesa_amt,
                                user_id:vm.user_id,
                                token:vm.token,
                            };
                            console.log("Payload | " + JSON.stringify(data));
                            $.ajax({
                                url: config.baseURL+'portal/reconcile',
                                type: 'POST',
                                data: JSON.stringify(payload),
                                success: function (response, textStatus, jQxhr) {
                                    console.log("Swap Matche: " + JSON.stringify(response));
                                    if (response.status_code == 200) {
                                        vm.$swal("Success!", response.status_description, "success");

                                    } else {
                                        vm.$swal("Error!", response.status_description, "error");
                                    }
                                },
                                error: function (jqXhr, textStatus, error) {

                                    vm.$swal("Error!", error, "error");
                                }
                            });
                        }
                    })

                }


                if (action == 'edit') {

                    vm.deposit_data=data;

                    $('.ui.modal#reconcile').modal({
                        closable: true,
                    }).modal('show');


                }


            },


            upload(){

                var vm=this;

                var vm = this;

                if (vm.upload_loader) {
                    return;
                }

                var jsondata = {
                    mpesa_code: vm.mpesa_code,
                    deposit_amount: vm.mpesa_amt,
                    status_description: vm.description,
                };

                // vm.upload_loader = 'loading';

                vm.deposit_mpesa=jsondata;


                $('.ui.modal#upload').modal({
                    closable: true,
                }).modal('show');

            },




            checktimer:function(){
                var vm=this;
                const itemStr = localStorage.getItem("timer")
                // if the item doesn't exist, return null
                if (!itemStr) {
                    return null
                }
                const item = itemStr

                var checktimer = new Date(item);

                const now = new Date()
                // compare the expiry time of the item with the current time
                if (now.getTime() > checktimer.getTime()) {
                    // If the item is expired, delete the item from storage
                    // and return null
                    localStorage.removeItem("timer");
                    localStorage.removeItem("user_info");

                    const Toast = vm.$swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 9000
                    });
                    Toast.fire({
                        type: 'error',
                        title: "Your session expired, Please login again "
                    })

                    vm.$router.push({name: 'login'});
                    return null
                }

            },

            dateFilter: function (start, end) {

                var vm = this;


                vm.start = start;
                vm.end = end;


                vm.moreParams.start = vm.start;
                vm.moreParams.end = vm.end;
                vm.moreParams.token = vm.token;


                this.$refs.vuetable.reload();

                console.log("start date filter cheacker",vm.start)
                console.log("end date filter cheacker  ",vm.end)
            },

            onFocus: function() {

                var vm = this;

                var start = moment();
                var end = moment();

                function cb(start, end) {
                    vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
                }

                $('input[name="dates"]').daterangepicker({
                    startDate: start,
                    endDate: end,
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                }, cb);

                cb(start, end);

            },


            searchMatches:function(){
                this.moreParams.filter = this.search_match;
                this.$refs.vuetable.reload();
            },

            depositedAt: function (value) {
                if (!value) {
                    return '-';
                } else {
                    return moment(value).format('DD MMMM YYYY, h:mm a');
                }
            },

            createdAt: function (value) {
                if (!value) {
                    return '-';
                } else {
                    return moment(value).format('h:mm a,DD MMM YYYY');
                }

            },

            dataManager(sortOrder, pagination) {
                if (this.data.length < 1) return;

                let local = this.data;

                // sortOrder can be empty, so we have to check for that as well
                if (sortOrder.length > 0) {
                    console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                    local = _.orderBy(
                        local,
                        sortOrder[0].sortField,
                        sortOrder[0].direction
                    );
                }

                pagination = this.$refs.vuetable.makePagination(
                    local.length,
                    this.perPage
                );
                console.log('pagination:', pagination)
                let from = pagination.from - 1;
                let to = from + this.perPage;

                return {
                    pagination: pagination,
                    data: _.slice(local, from, to)
                };
            },


            onPaginationData(paginationData) {
                this.$refs.paginationInfo.setPaginationData(paginationData)
                this.$refs.pagination.setPaginationData(paginationData)
            },


            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },


            onLoading() {
                this.loading = true
                console.log('loading... show your spinner here')
            },
            onLoaded() {
                this.loading = false
                console.log('loaded! .. hide your spinner here')
            },




        },


    }

</script>




